// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"fe0bf8fc","589":"3b53517f","604":"3b53517f","750":"3b53517f","996":"2665251a"}[chunkId] + ".chunk.css";
};